import { styled as muiStyled } from '@mui/material/styles';
import { Box } from '@mui/material'
import { fontSize } from 'styles/theme'

export const NewAffiliationDashboardStyles = muiStyled(Box)(({ theme, $systemUI }) => {
    return {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100%",
        rowGap: 20,
        justifyContent: "space-around",

        // justifyContent: "strat",
        [theme.breakpoints.down('xxl')]: {
            justifyContent: "space-around",
        },
        [theme.breakpoints.down('xl')]: {
            overflow: "auto"
        },
        '.card-title': {
            fontWeight: "bold",
            fontSize: fontSize + 1.5
        },
        '.card-description': {
            textAlign: "center",
        },
        '.step-number': {
            color: "#0000004D",
            height: 40,
            display: "flex",
            alignItems: "center"
        },
        '.wrap-cartoon': {

        },
        '.header': {
            marginTop: 20,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            rowGap: 2,
        },
        '.affiliation-name-title': {
            fontWeight: "bold",
            fontSize: fontSize + 3,
            marginBottom: 3
        },
        '.sub-title': {

        },
        '.card': {
            borderRadius: 15,
            background: "white",
            padding: "10px 40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            rowGap: 4,
            width: 240,
            height: 440,
            [theme.breakpoints.down('xxl')]: {
                height: 400,
                width: 220,
            },
            [theme.breakpoints.down('xl')]: {
                height: 420,
                width: 420,
            }
        },
        '.step-cards': {
            display: "flex",
            justifyContent: "center",
        },
        '.cards': {
            display: "flex",
            [theme.breakpoints.down('xl')]: {
                flexDirection: "column",
                rowGap: 15
            }
        }
    }
});

export const CartoonStyles = muiStyled(Box)(({ theme, width, height }) => {
    return {
        width: width,
        height: height,
        [theme.breakpoints.down('xxl')]: {
            width: width * 0.75,
            height: height * 0.75,
        }
    }
})
